/* Auto Generated */

export enum GuideSectionItemType {
    text,
    link,
    image,
    markdown,
    table,
}
